export const columns = [
    { title: 'PS_ID', maxWidth: '150px' },
    { title: 'Title', maxWidth: '250px' },
    {
      title: 'Description',
      maxWidth: '350px',
      isExpandable: true
    },
    { title: 'Category', maxWidth: '125px' },
    { title: 'Organization', maxWidth: '250px' }
  ];
  
  
    export const rows = [
              [
          "CX001",
          "Smart Irrigation System for Precision Farming",
          "Develop a smart irrigation system that utilizes sensors and IoT technology to monitor soil moisture levels and weather conditions. The system will provide real-time data to farmers, enabling them to make informed decisions on irrigation scheduling, optimizing water usage and enhancing crop yield.",
          "Hybrid",
          "Ministry of Agriculture and Farmers Welfare"
        ],
        [
          "CX002",
          "Job Engine for Uneducated Individuals",
          "Design a VoIP-based job search engine targeted at uneducated individuals. This tool should simplify job applications by providing voice instructions and search capabilities without needing literacy skills, supporting job access for those without traditional education.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX003",
          "Automatic Change Detection in SAR Images",
          "Develop an automatic change detection system for Synthetic Aperture Radar (SAR) satellite images to identify man-made changes while ignoring natural changes. The solution can leverage Sentinel 1 SAR Open source satellite images and Google Earth Engine.",
          "Software",
          "National Technical Research Organisation (NTRO)"
        ],
        [
          "CX004",
          "Chrome Extension for Amazon Product Details",
          "Develop a Chrome extension to provide additional Amazon product details such as origin, returnable and refundable status, and other specifics, enhancing shopping transparency directly from the browser.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX005",
          "Automatic Road Extraction and Alert Generation",
          "Develop an automated road extraction solution using medium-resolution satellite images from ISRO’s Boonidhi portal. The solution should generate alerts for new road developments compared to previous images and store road data in a GIS database.",
          "Software",
          "National Technical Research Organisation (NTRO)"
        ],
        [
          "CX006",
          "Virtual Coworking Office Platform",
          "Create a virtual coworking office platform where users can collaborate with audio, video, and messaging features in real time, replicating a physical office environment to foster team interactions and productivity.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX007",
          "Development of Innovative Flushing System",
          "Design an innovative public toilet flushing system to ensure maximum usable area gets cleaned automatically without electronic components. The system should activate post-use and support high-usage environments.",
          "Hardware",
          "Department of Science and Technology"
        ],
        [
          "CX008",
          "Bulk Certificate Generator Platform",
          "Develop a portal to generate bulk certificates with automated registration and download functionality, ideal for large events, simplifying the certificate distribution process.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX009",
          "Development of Non-electrical Sun Tracker",
          "Design a cost-effective, non-electrical sun tracking device for solar panels. The device should adjust the orientation of solar panels to maintain optimal sunlight exposure throughout the day, enhancing energy efficiency.",
          "Hardware",
          "Department of Science and Technology"
        ],
        [
          "CX010",
          "Mock Bank for Kids",
          "Build a mock bank application for kids where they can engage in simulated transactions and manage finances, helping them learn about money management and financial literacy.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX011",
          "Gift Delivery Estimator for Amazon",
          "Develop an app to determine delivery dates and availability for specific gift types on Amazon, helping users plan gifts with approximate arrival times to ensure timely delivery.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX012",
          "Student Innovation: Tourism Boost",
          "Submit ideas for innovative solutions that can boost the current situation of the tourism industries including hotels, travel, and others.",
          "Software",
          "AICTE, MIC-Student Innovation"
        ],
        [
          "CX013",
          "Multi-device Switch for Mouse/Keyboard",
          "Create a hardware solution enabling a mouse and keyboard to switch between devices using gestures, offering an accessible experience for multi-device users without manual switching.",
          "Hardware",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX014",
          "Image Recoloring Tool",
          "Build an image recoloring tool that applies brand colors to images without distortion, allowing users to align visuals with branding requirements seamlessly.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX015",
          "Student Innovation: Resource Management",
          "Submit ideas to address the growing pressures on the city’s resources, transport networks, and logistic infrastructure.",
          "Hardware",
          "AICTE, MIC-Student Innovation"
        ],
        [
          "CX016",
          "Social Media Link-Based Community Platform",
          "Design a social platform where users can share, preview, and interact with content links. It should allow link drafts, approvals, and publication, serving as a community-driven content-sharing app.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX017",
          "Scam Awareness Tool for the Elderly",
          "Develop a scam awareness tool aimed at protecting elderly individuals from fraud, providing education on common scams and offering reporting mechanisms for quick assistance.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX018",
          "Student Innovation: Cultural Heritage",
          "Submit ideas to showcase and preserve the rich cultural heritage and traditions of India.",
          "Software",
          "AICTE, MIC-Student Innovation"
        ],
        [
          "CX019",
          "Trading Bot for Kite0",
          "Build an automated trading bot for Kite0 that follows specific price ranges and makes investment decisions based on criteria like market trends and predefined investment strategies.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX020",
          "Student Innovation: Renewable Sources",
          "Submit innovative ideas that help manage and generate renewable or sustainable sources more efficiently.",
          "Hardware",
          "AICTE, MIC-Student Innovation"
        ],
        [
          "CX021",
          "B2B E-commerce Catalogue",
          "Create an invite-only, private B2B e-commerce catalog, designed to give exclusive access to products for business clients, enhancing privacy and targeting the B2B customer segment.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX022",
          "Student Innovation: Toys & Games",
          "Submit creative ideas that challenge participants to conceptualize and develop unique toys & games.",
          "Software",
          "AICTE, MIC-Student Innovation"
        ],
        [
          "CX023",
          "Real-time Voice Chat App",
          "Develop a real-time voice chat app focused on specific topics, utilizing a predefined dataset to facilitate topic-driven discussions. This can be used in educational, collaborative, or interactive environments.",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX024",
          "Student Innovation: Fitness & Health",
          "Submit innovative ideas that can boost fitness activities and assist in keeping fit.",
          "Software",
          "AICTE, MIC-Student Innovation"
        ],
        [
          "CX025",
          "Student Innovation: AI Integration",
          "Submit ideas focused on the intelligent use of resources for transforming and advancing technology by integrating artificial intelligence.",
          "Hybrid",
          "AICTE, MIC-Student Innovation"
        ],
        // New entries
        [
          "CX026",
          "Optimizing Energy Efficiency in Smart Devices",
          "How can we design smart devices to consume less energy while maintaining high performance?",
          "Hardware",
          "Ministry of Agriculture and Farmers Welfare"
        ],
        [
          "CX027",
          "Designing Scalable Cloud Storage Solutions",
          "How can we create a cloud storage system that is scalable, cost-effective, and secure for organizations with massive data requirements?",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX028",
          "Enhancing Battery Life of Wearable Devices",
          "What innovations in battery technology can help extend the battery life of wearable devices like fitness trackers and smartwatches?",
          "Hardware",
          "Department of Science and Technology"
        ],
        [
          "CX029",
          "Creating Secure IoT Networks",
          "How can we design IoT networks that are resilient to cyber-attacks and maintain data integrity for organizations operating large-scale IoT deployments?",
          "Hybrid",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX030",
          "Developing Cost-effective Edge Computing Devices",
          "How can we create edge computing devices that are both cost-effective and high-performance for applications in industries like healthcare, manufacturing, and smart cities?",
          "Hardware",
          "Department of Science and Technology"
        ],
        [
          "CX031",
          "Improving the Durability of Consumer Electronics",
          "What materials and designs can be used to improve the durability and lifespan of consumer electronics like smartphones, tablets, and laptops?",
          "Hardware",
          "National Technical Research Organisation (NTRO)"
        ],
        [
          "CX032",
          "Designing AI-based Predictive Maintenance Systems",
          "How can AI be used to predict and prevent system failures in critical hardware infrastructure used by large organizations, such as data centers and manufacturing plants?",
          "Hybrid",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX033",
          "Building User-friendly Data Analytics Tools",
          "How can we create data analytics tools that are user-friendly for non-technical users, enabling them to extract insights from data without advanced technical skills?",
          "Software",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX034",
          "Innovating Water Filtration Systems",
          "What innovative technologies can be applied to enhance water filtration systems for both residential and industrial applications, ensuring clean and safe drinking water?",
          "Hybrid",
          "Department of Science and Technology"
        ],
        [
          "CX035",
          "Creating Sustainable Packaging Solutions",
          "How can we design packaging that is both sustainable and functional, addressing the growing concerns over plastic waste?",
          "Hybrid",
          "Ready Bytes Software Labs Pvt. Ltd."
        ],
        [
          "CX036",
          "Leveraging Blockchain for Supply Chain Transparency",
          "How can blockchain technology be applied to improve transparency and traceability in supply chain management?",
          "Software",
          "National Technical Research Organisation (NTRO)"
        ],

        [
            "CX037",
            "Smart Safety Device for Preventing Mobile Phone Distraction While Riding on Indian Roads",
            "Mobile phone usage while riding a bike is a common yet dangerous practice on Indian roads, contributing to a high number of road accidents. Riders often use their phones for calls, texting, or navigation while in motion, which significantly distracts them from the road. The lack of an effective deterrent or system to prevent mobile usage while riding poses a substantial risk to both the rider and others on the road.\n\nObjective:\nTo design and develop a device that prevents or discourages the use of mobile phones while riding a bike, ensuring the rider’s attention remains focused on the road. This device should be reliable, user-friendly, and compatible with the diverse conditions on Indian roads.",
            "Hybrid",
            "Dept. of Mechanical Engg."
          ],
          [
            "CX038",
            "Alumni Website Development",
            "In today’s digital age, maintaining a strong connection between alumni and their alma mater is crucial for fostering community, networking opportunities, and continued engagement. However, our institution currently lacks a centralized online platform for alumni to connect, share experiences, and access important resources.\n\nObjectives:\n- Develop a user-friendly alumni website that facilitates communication and interaction among former students.\n- Provide a space for alumni to update their profiles, share career achievements, and post job opportunities.\n- Include features for event announcements, news updates, and forums for discussion.\n- Integrate social media sharing options to enhance visibility and engagement.\n- Ensure the website is mobile-responsive and accessible to users with varying levels of technical proficiency.\n\nScope: The project will involve the design and development of the website, including:\n- User registration and authentication\n- Profile management for alumni\n- A news and events section\n- Discussion forums\n- Job board functionality\n\nExpected Outcome: By the end of this project, we aim to create a vibrant online community where alumni can connect, collaborate, and contribute to the growth of future generations while strengthening their ties to the institution.",
            "Software",
            "Dept. of Information Technology"
          ],
          [
            "CX039",
            "College Placement Portal Development",
            "In the current landscape of higher education, facilitating student placements effectively is vital for ensuring successful career opportunities. However, our college lacks a streamlined, centralized online platform for managing the placement process, leading to inefficiencies and challenges in connecting students with potential employers.\n\nObjectives:\n- Develop a user-friendly placement portal that allows students to upload their profiles and relevant data securely.\n- Enable placement officers and authorized representatives to verify student data and filter profiles based on specific requirements set by various companies.\n- Provide companies with access to the portal to streamline their recruitment processes, including organizing tests and managing selection stages.\n\nScope: The project will encompass the following features:\n- Student Registration: Allow students to create accounts and upload their data, including resumes, academic records, and personal information.\n- Data Verification: Enable placement officers to review and verify student information before it is made visible to companies.\n- Filtering Mechanism: Implement filtering options for placement officers to match students with suitable job openings based on company requirements.\n- Company Login: Allow companies to create accounts, access student profiles, organize recruitment tests, and manage various stages of the selection process.\n- Dashboard: Provide users (students, placement officers, and companies) with a dashboard to track applications, test schedules, and notifications.\n\nExpected Outcome: By developing this College Placement Portal, we aim to enhance the efficiency of the placement process, improve communication between students and companies, and ultimately increase the success rate of student placements.",
            "Software",
            "Training & Placement Cell"
          ],
          [
            "CX040",
            "AI-Driven Quiz Automation System for Moodle LMS",
            "Your task is to develop an AI-based solution that automates quiz generation within the Moodle Learning Management System (LMS). The goal is to create a system that can automatically generate Multiple-Choice Questions (MCQs) and Multi-Select Questions (where more than one answer or a combination of answers are correct) from course content, using open-source large language models (LLMs).\n\nPlease note that the project must be completed using free, open-source tools; we will not bear any expenses for the development.\n\nAs part of this project, you will design and implement an AI-driven tool that helps educators generate quizzes automatically within Moodle. The focus will be on generating two types of questions:\n* Multiple-Choice Questions (MCQs): One correct answer and multiple distractors.\n* Multi-Select Questions: Multiple correct answers or combinations of correct answers.\n\nYour system will need to:\n* Use any available open-source LLMs to analyze course material (available in file formats such as PDFs, docs, images, videos) and extract key concepts that can be transformed into quiz questions.\n* Ensure questions generated are appropriate for the subject matter and learning objectives of the course.\n* Create varied question and answer orders to prevent patterns and ensure a diverse assessment experience, ensuring questions for all levels: easy, medium, and difficult.\n* Ensure the questions generated are grammatically correct, clear, and free from ambiguity. Instructors should also have the option to review and edit the questions before they are used in a live quiz.\n\nThis tool should allow instructors to generate quizzes with minimal effort while maintaining academic quality.\n\nDeliverables:\n* A working AI-powered quiz generator integrated with Moodle LMS.\n* Detailed documentation outlining how to set up and use the system.\n* A report on how the open-source LLM was chosen and integrated.\n* A demonstration of the tool in action, generating questions from sample course material.",
            "Software",
            "Take2 Technologies"
        ],
        [
            "CX041",
            "Real-Time Scanning App for OMR Sheets",
            "The manual checking of OMR sheets is a time-consuming process, and buying an OMR scanner is a costly affair for a small or medium academic institution. Hence, Testntrack wants to build a real-time scanner through which the result will be generated instantly.\n\nHow it should work:\n- The person should open an app to scan the OMR sheet and put its mobile camera over the sheet. Without pressing any button, the screen should show the marks with the numbering of wrong questions on the screen only.",
            "Software",
            "Dot Hundred Technologies Pvt. Ltd."
        ],
        [
            "CX042",
            "Subjective Assessment (Copy Checking)",
            "In today's world, teachers are overburdened with tasks such as teaching, copy-checking, feedback, etc. It takes them 10 to 15 minutes to manually check descriptive answer copies of students. Testntrack wants to change this practice with the help of AI.\n\nHow it should work:\n- The teacher would scan the answer copy and then upload it to our platform. First, you need to build a system to recognize the handwriting of students by making handwriting patterns. With our predefined database of question answers, the answers will be checked automatically, and marks will be given based on the percentage of accuracy.\n\nHow to check the accuracy:\n- Every question should have key points. Total marks would be divided by the number of key points. Hence, you will get the value of each key point, and to reward the marks, just multiply the number of key points with the weightage. You will get a score on every question.",
            "Software",
            "Dot Hundred Technologies Pvt. Ltd."
        ],
        [
            "CX043",
            "How to Improve Rubbing and Washing in Screen Pigment Printing",
            "How to improve the rubbing and washing fastness in screen/block pigment printing... Pigment printing needs to improve rubbing and washing fastness.",
            "Hybrid",
            "Art India"
        ],
        [
          "CX044",
          "Use Generative AI to provide an explanation for any type of fraud",
          "Fraud is a big problem in the industry, however it is really difficult to educate fraud analysts about various types of fraud that occurs and it slows down the fraud detection process. With the use of Generative AI, the learning new fraud can become fast. As part of this idea, please ideate over a Generative AI based solution that help fraud analysts learn about possible fraud patterns that their data is seeing etc and recommend them for a manual review etc to make sure the analyst manually review the suggest fraud and apply appropriate fraud labels.",
          "Software",
          "Arun Pokharna"
      ],
      [
        "CX045",
        "AI News Aggregator and Converter",
        "Looking for a solution that could aggregate news/ updates from different platform , rephrase it in local language with brand header and push in as web notification to subscribers.",
        "Software",
        "DKD Digital",
      ],
      [
        "CX046",
        "News blog web application",
        "App that connects/enables journalist from several areas to create blog, the application after basic filtering converte blog to news and flush the news to various platforms pages based on category of news.",
        "Software",
        "DKD Digital",
      ],
        ];
